(function($, undefined) {
	
	'use strict';
	var scrollUtil;
	var utils;
	var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend'; 

	var init = function (page) {
		var currPage = $(page);
		utils = Fw.component.models().utils; 
		scrollUtil = Fw.modules.models().header;
		
		$('.lining-text').each(function() {
			var text = $(this).children('.js-editable-receiver').get(0);
			if (isOverflowedY(text)) {
				$(text).siblings('.lining-text-bottom-gradient').addClass('show');
			}
		});
		
		$('.window-readmore').appendTo('body');
		
		$('.lining-readmore-btn').click(function() {
		    var localId = $(this).data('localId');
		    openPopup('readmore-' + localId);
		});
		$('.close_popup, .gallery-popup-close').click(function() {
		    var localId = $(this).data('localId');
		    closePopup('readmore-' + localId);
		    closePopup('gallery-popup-' + localId);
		});
		$('.lining-settings-update-btn-display').click(function() {
		    var localId = $(this).data('localId');
		    var btnReadmoreChecked = $('#btn-readmore-' + localId).is(":checked");
		    var btnHideChecked = $('#btn-hide-' + localId).is(":checked");
		    utils.updateLabelLangs('btn-hide-'+localId, btnHideChecked, 'en,fr'); 
		    utils.updateLabelLangs('btn-readmore-'+localId, btnReadmoreChecked, 'en,fr'); 
		});
		$('.lining-img-blue-overlay-option-ctn input').on('change', function() {
			var isBlue = $(this).is(':checked');
			var liningImage = $(this).parents('.lining-img');
			var localId = $(this).parents('label').data('localId');
			var labelValue = "";
			if (isBlue) {
				if (!liningImage.hasClass('blue-overlay')) {
					liningImage.addClass('blue-overlay');
				}
				labelValue = "blue-overlay";
			}
			else {
				if (liningImage.hasClass('blue-overlay')) {
					liningImage.removeClass('blue-overlay');
				}
				labelValue = "";
			}
			utils.updateLabelLangs('lining-img-blue-overlay-' + localId, labelValue, 'en,fr');
		});
		
	};
	
	function isOverflowedY(element){
	    return element.scrollHeight > element.clientHeight;
	}
	
	//open popup window and disable scroll
	var openPopup = function(id) {
	    var element = $("#" + id);
	    element.addClass('show');
	    
	    element.one(transitionEnd, function(e) {
	    	if(!e.originalEvent.pseudoElement) {
	    		$(document).one('click', outsideClickReadmorePopup);
	    	}
	    });
	    
	    scrollUtil.toggleScroll(false);
	};

	var closePopup = function(id) {
	    var element = $("#" + id);
	    element.removeClass('show');
	   
		scrollUtil.toggleScroll(true);
	};
	
	var outsideClickReadmorePopup = function (event) {
	    if (!$(event.target).closest('.readmore-content').length) {
	        closePopup($(".window-readmore.show").attr('id'));
	    }
	};
	
	var lining = Fw.modules.export('lining', {
		init: init
	});
	
})(jQuery);

